<template>
  <v-data-table
    :headers="headers"
    :items="data"
    disable-pagination
    hide-default-footer
  >
    <template #item.name="{item}">
      <code>{{item.name}}</code>
    </template>
    <template #item.description="{item}">
      <markdown
        v-if="item.description"
        :source="item.description"
      />
    </template>
    <template #item.props="{item}">
      <params-table
        v-if="item.props.length"
        :data="item.props"
      />
      <div v-else>
        No props
      </div>
    </template>

  </v-data-table>
</template>

<script>
import ParamsTable from '@/components/componentPreview/ParamsTable';
import Markdown from '@/components/Markdown';

export default {
  name: 'SlotsTable',
  components: {Markdown, ParamsTable},
  props: {
    data: Array,
  },
  data() {
    return {
      headers: [
        {text: 'Name', value: 'name'},
        {text: 'Description', value: 'description'},
        {text: 'Props', value: 'props', sortable: false},
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
>>> td:last-child {
    width: 50%;
  }
</style>
